import { Component, OnInit, ViewChild, enableProdMode } from '@angular/core';
import { DxDataGridComponent, DxScrollViewComponent } from 'devextreme-angular';
import { OrganismoService } from '../../../services/formulacion/organismo.service';
import { UtilHelper } from '../../../_helpers/util';
import { environment } from '../../../../environments/environment';
declare const toastr: any;

@Component({
  selector: 'app-organismo',
  templateUrl: './organismo.component.html',
  styleUrls: [],
  providers: [OrganismoService]
})

export class OrganismoComponent implements OnInit {
  @ViewChild(DxDataGridComponent) dataGrid: DxDataGridComponent;
  dataResourceOR: any[];
  model: any = {
    id: 0,
    codigo: '',
    sigla: '',
    descripcion: '',
    selector: '',
    es_vigente: true
  };
  organismoId: number;
  popupVisibleAdd: boolean = false;
  popupVisibleDel: boolean = false;
  state_toogle: boolean = false;
  vigencia: any[];
  baseUrl = environment.apiEndpoint;
  hasError: any;
  tipo_agregacion_id: number = 1;;  
  unidad_organizacional_id: number = 0;
  constructor(private _os: OrganismoService) {
    this.vigencia = [{ text: 'Activo', value: true }, { text: 'Inactivo', value: false }];
    this.clearErrors();
    this.getOrganismos();
    let u = JSON.parse(localStorage.getItem('u'));           
    this.tipo_agregacion_id = 1;    
    this.unidad_organizacional_id = u.unidad;    
  }

  ngOnInit() {
  }

  clearErrors() {
    this.hasError = { codigo: false, sigla: false, descripcion: false, selector: false };
  }

  getOrganismos() {
    this._os.getOrganismo().subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.dataResourceOR = result.data;
        } else {
          this.dataResourceOR = [];
        }
      },
      (error) => {
        console.log('Error', error);
      });
  }

  onToolbarPreparing(e) {
    e.toolbarOptions.items.unshift({
      location: 'before',
      template: 'acciones'
    });
  }

  showModalAdd() {
    this.clearErrors();
    this.model.id = 0;
    this.model.codigo = '';
    this.model.sigla = '';
    this.model.descripcion = '';
    this.model.selector = '';
    this.model.es_vigente = true;
    this.state_toogle = false;
    this.popupVisibleAdd = true;
  }

  showModalEdit(data: any) {
    this.clearErrors();
    this.model.id = data.id;
    this.model.codigo = data.codigo;
    this.model.sigla = data.sigla;
    this.model.descripcion = data.descripcion;
    this.model.selector = data.selector;
    this.model.es_vigente = data.es_vigente;
    this.state_toogle = true;
    this.popupVisibleAdd = true;
  }

  concatSelector() {
    this.model.selector = this.model.codigo + ' - ' + this.model.sigla
  }

  saveOrganismo() {
    this.hasError = { codigo: false, sigla: false, descripcion: false, selector: false };
    if (this.validate(this.model)) {
      if (this.model.id == 0) {
        this._os.postOrganismo(this.model).subscribe(
          response => {
            let result = UtilHelper.responses(response);
            if (result.status == 200) {
              this.getOrganismos();
              this.popupVisibleAdd = false;    
              toastr.success('Datos guardados correctamente.');          
            } else {              
              toastr.warning(result.data);              
            }
          },
          error => { console.log('Error', error); });
      }
      else {
        this._os.putOrganismo(this.model).subscribe(
          response => {
            let result = UtilHelper.responses(response);
            if (result.status == 200) {
              this.getOrganismos();
              this.popupVisibleAdd = false;     
              toastr.success('Datos actualizados correctamente.');         
            } else {
              toastr.warning(result.data);              
            }
          },
          error => { console.log('Error', error); });
      }
    }
  }

  showModalDelete(id: number) {
    this.organismoId = id;
    this.popupVisibleDel = true;
  }

  deleteOrganismo() {
    this._os.deleteOrganismo(this.organismoId).subscribe(
      response => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.getOrganismos();
          this.popupVisibleDel = false;          
        } else {
          console.log('Error', 'al agregar');
        }
      },
      error => { console.log('Error', error); });
  }

  validate(data: any) {
    let res = true;
    if (!UtilHelper.validator(data.codigo, 'text')) {
      this.hasError.codigo = true; res = false;
    }
    if (!UtilHelper.validator(data.sigla, 'text')) {
      this.hasError.sigla = true; res = false;
    }
    if (!UtilHelper.validator(data.descripcion, 'text')) {
      this.hasError.descripcion = true; res = false;
    }
    if (!UtilHelper.validator(data.selector, 'text')) {
      this.hasError.selector = true; res = false;
    }
    return res;
  }
}
